import Link from "next/link";
import type { ComponentProps } from "react";
import { isExternalHref, isPlainAnchorHref } from "@/lib/href";

export function NewTabHint() {
  return <span className="sr-only"> (opens in a new tab)</span>;
}

export function MDXAnchor({
  href = "",
  children,
  ...props
}: ComponentProps<"a">) {
  if (isExternalHref(href)) {
    return (
      <a
        className="article-underline"
        href={href}
        rel="noopener"
        target="_blank"
        {...props}
      >
        {children}
        <NewTabHint />
      </a>
    );
  }

  if (isPlainAnchorHref(href)) {
    return (
      <a className="article-underline" href={href} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link className="article-underline" href={href} {...props}>
      {children}
    </Link>
  );
}
